// extracted by mini-css-extract-plugin
export default {"sideWrapper":"expanel_sideWrapper__8pkM+","contentWrapper":"expanel_contentWrapper__5cyoz"};